import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type * as current from '../../../utils/types/sharedTypes'
import type { UpBlockHandler } from '../types'
import { findBlockIdWithinStep, newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.SummaryBlock> = (uischema, _, journey) => {
  if (uischema.type !== CONTROL_NAME.SUMMARY_CONTROL) {
    throw new Error('Expected a valid Summary control')
  }

  if (!journey) {
    throw new Error('Expected a valid journey')
  }

  const references = upCustomSummaryFieldsAsReferences(
    uischema.options?.fields,
    journey
  )

  return {
    type: next.BLOCK_TYPE.SUMMARY,
    required: false,
    settings: {
      ...upCommonSettings(uischema),
      subTitle: uischema.options?.subTitle
    },
    references
  }
}

export const upCustomSummaryFieldsAsReferences = (
  fields: string[],
  journey: current.Journey
) => {
  const references: Record<next.ReferenceId, next.SummaryBlockReference> = {}

  if (!fields) {
    return references
  }

  fields.forEach((field: string) => {
    // DISPLAY/STEP_INDEX/ORIGINAL_NAME/CUSTOM_NAME
    const [display, stepIndex, originalName, customName] = field.split('/')

    const blockId = findBlockIdWithinStep(
      journey,
      Number(stepIndex),
      originalName
    )

    // If blockId is not found, skip creating a reference for it
    // This is a case when the block was deleted but the summary config was never updated
    if (!blockId) {
      return
    }

    const referenceId = newId<next.ReferenceId>()

    references[referenceId] = {
      display: display?.toLowerCase() === 'true',
      titleOverride: customName ? customName : undefined,
      meaning: 'display-setting',
      referenceType: next.REFERENCED_TYPE.BLOCK,
      referenceId: blockId,
      id: referenceId
    }
  })

  return references
}
